module.exports = __webpack_public_path__ + "2471916aa196e9f734c868c0ef90c0eb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/space-vision-house-empty.png
// module id = 330
// module chunks = 0